import React, { Component } from 'react';
import { isMobile, isIOS, isSafari, isChrome } from 'react-device-detect';
import classes from './UsernameStep.module.css';
import strings from '../../../../../assets/localization';
import Button from '../../../../UI/Button/Button';
import Input from '../../../../UI/Input/Input';
import InputError from '../../../../UI/InputError/InputError';
import StepHeader from '../StepHeader/StepHeader';
import { gtmTrack } from '../../../../../assets/helpers/GAHelper';
import {
  validateUsername,
  checkUsernameForNumbersOnly,
} from '../../../../../assets/helpers/utils';

export default class UsernameStep extends Component {
  constructor(props) {
    super(props);
    this.textInput = React.createRef();
    this.state = { usernameError: '', username: '', isDirty: false };
  }

  componentDidMount() {
    if (this.props.username === '') {
      this.textInput.focus();
    } else {
      this.setState({ username: this.props.username });
    }
  }

  componentDidUpdate(prevProps) {
    // console.log('STEP 4 NEXT PROPS:::', this.props);

    // Handle successful username check
    if (
      this.props.checkUsername.status === 'success' &&
      this.props.checkUsername.status !== prevProps.checkUsername.status
    ) {
      this.props.goToStep(5);
    }

    // Handle failed username check
    if (
      this.props.checkUsername.status === 'fail' &&
      this.props.checkUsername.status !== prevProps.checkUsername.status &&
      this.props.checkUsername.fromPage === 'StepFour-modal'
    ) {
      this.setState({ usernameError: this.props.checkUsername.error.error });
      gtmTrack({
        event: 'signup_error',
        message: this.props.checkUsername.error.error,
      });
    }

    // Update username state when props change
    if (prevProps.username !== this.props.username) {
      this.setState({ username: this.props.username });
    }
  }

  _handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      this.props.setUsername(this.state.username);
      this._checkUsername();
      this._checkUsernameErrors(this.state.username);
    }
  };

  _onChange = (e) => {
    const {
      target: { value },
    } = e;
    this.setState({ username: value });

    if (value.length > 5 && !this.state.isDirty) {
      this.setState({ isDirty: true });
    }

    this._checkUsernameErrors(value);
  };

  _checkUsername = () => {
    if (this._validateUsername()) {
      this.props.nbsApiCheckUsername(
        { username: this.state.username },
        'StepFour-modal'
      );
    }
  };

  _validateUsername = () => {
    const { username } = this.state;
    const { usernameError } = this.state;

    return validateUsername(username) && usernameError === '';
  };

  _checkUsernameErrors = (username) => {
    if (this.state.isDirty) {
      if (!validateUsername(username)) {
        this.setState({ usernameError: strings.lettersAndNumbersOnly });
      } else {
        if (checkUsernameForNumbersOnly(username)) {
          this.setState({ usernameError: strings.useAtLeastOneLetter });
        } else {
          this.setState({ usernameError: '' });
        }
      }
    }
  };

  _onNextClick = () => {
    this.props.setUsername(this.state.username);
    this._checkUsername();
  };

  render() {
    // console.log('STEP 4 RENDER:', this.state);
    const { hideHeader, isLandscape } = this.props;
    const { username } = this.state;

    let cssStyles = classes.StepTwo;
    let safariSafeHideHeader = isMobile && isIOS ? false : hideHeader;

    return (
      <div className={cssStyles}>
        <StepHeader
          hideHeader={!isLandscape && safariSafeHideHeader}
          headerText={strings.chooseUsername}
          subheaderText={strings.itWillBeYourBio}
          activeStep={4}
          pageCount={5}
        />
        <div className={classes.ContentWrapper}>
          <div className={classes.InputWrapper}>
            <Input
              setRef={(component) => {
                this.textInput = component;
              }}
              type='text'
              value={username}
              onChange={this._onChange}
              onKeyDown={this._handleKeyDown}
              label={strings.usernameLabel}
              labelSmall={strings.usernameLabelSmall}
              placeholder={strings.usernamePlaceholder}
              maxLength={14}
            />
            <InputError
              style={{
                display: this.state.usernameError !== '' ? 'block' : 'none',
              }}
            >
              {this.state.usernameError}
            </InputError>
          </div>
          <div
            className={classes.Footer}
            style={{
              justifyContent:
                isIOS && !isLandscape && (isSafari || isChrome)
                  ? 'flex-start'
                  : 'flex-end',
            }}
          >
            <Button
              disabled={
                !this._validateUsername() ||
                checkUsernameForNumbersOnly(this.state.username)
              }
              clicked={this._onNextClick}
            >
              {strings.next}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Auth/EmailRegister/Steps/UsernameStep/UsernameStep.js